import { optional } from "AppReact/schema";

export default {
  id: optional('integer'),
  name: optional('string'),
  unit: optional('string'),
  email: optional('string'),
  phone: optional('string'),
};
